import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
    container: {
        backgroundColor: '#E3ECFA',
        height: .5,
        width: '100%',
    }
});